// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/mlops/batch/v1/job.proto (package ai.h2o.mlops.batch.v1, syntax proto3)
/* eslint-disable */

// (-- api-linter: core::0215::foreign-type-reference=disabled
//     aip.dev/not-precedent: Required to enable monitoring support in version 2. --)

import type { MonitoringOptions } from "../../monitoring/v2/monitoring_options_pb";
import type { BigIntString } from "../../../../../runtime";
import { getNameParser } from "../../../../../runtime";

/**
 * Job is entity representing Batch Scoring Job
 *
 * @generated from message ai.h2o.mlops.batch.v1.Job
 */
export type Job = {
/**
 * Resource name.
 *
 * @generated from field: string name = 1;
 */
name?: string;
/**
 * Optional. Human-readable name.
 *
 * @generated from field: string display_name = 2;
 */
displayName?: string;
/**
 * Required. Configuration for the data source from which input data will be read.
 *
 * @generated from field: ai.h2o.mlops.batch.v1.Source source = 3;
 */
source: Source;
/**
 * Required. Configuration for the data sink where processing results will be written.
 *
 * @generated from field: ai.h2o.mlops.batch.v1.Sink sink = 4;
 */
sink: Sink;
/**
 * Required. Specification for the instance that will execute the batch processing,
 * including deployment composition, resource allocation, and runtime configuration.
 *
 * @generated from field: ai.h2o.mlops.batch.v1.InstanceSpec instance_spec = 5;
 */
instanceSpec: InstanceSpec;
/**
 * Optional. Parameters controlling batch processing behavior such as batch size.
 * If not specified, default values will be used for optimal performance.
 *
 * @generated from field: ai.h2o.mlops.batch.v1.BatchParameters batch_parameters = 6;
 */
batchParameters?: BatchParameters;
/**
 * Optional. Parameters for configuring model inference requests, including
 * feature contributions, prediction intervals, and record identification options.
 *
 * @generated from field: ai.h2o.mlops.batch.v1.ModelRequestParameters model_request_parameters = 7;
 */
modelRequestParameters?: ModelRequestParameters;
/**
 * The current state of the Job.
 *
 * @generated from field: ai.h2o.mlops.batch.v1.Job.State state = 8;
 */
state?: Job_State;
/**
 * Output only. Name of an entity that created the Job.
 *
 * @generated from field: string creator = 9;
 */
creator?: string;
/**
 * Output only. Time when the job was created.
 *
 * @generated from field: google.protobuf.Timestamp create_time = 10;
 */
createTime?: string;
/**
 * Time when the Job started executing.
 *
 * @generated from field: google.protobuf.Timestamp start_time = 11;
 */
startTime?: string;
/**
 * Time when the Job completed.
 *
 * @generated from field: google.protobuf.Timestamp end_time = 12;
 */
endTime?: string;
/**
 * Batch-scoring job completion statistics after it has been completed or terminated.
 *
 * @generated from field: ai.h2o.mlops.batch.v1.CompletionStats completion_stats = 13;
 */
completionStats?: CompletionStats;
/**
 * Optional. Maximum allowed time for the job to run before being automatically timed out.
 * Example values in JSON: "15s", "10m", "1h".
 *
 * @generated from field: google.protobuf.Duration job_timeout = 14;
 */
jobTimeout?: string | null;
/**
 * Optional. Monitoring configuration for the job.
 *
 * @generated from field: ai.h2o.mlops.monitoring.v2.MonitoringOptions monitoring_options = 15;
 */
monitoringOptions?: MonitoringOptions;
/**
 * The current state of the Job.
 *
 * @generated from field: ai.h2o.mlops.batch.v1.Job.MonitoringState monitoring_state = 16;
 */
monitoringState?: Job_MonitoringState;
}
;
/**
 * State represents the current state of the job.
 *
 * @generated from enum ai.h2o.mlops.batch.v1.Job.State
 */
export enum Job_State {
/**
 * State is unspecified or unknown.
 *
 * @generated from enum value: STATE_UNSPECIFIED = 0;
 */
STATE_UNSPECIFIED = "STATE_UNSPECIFIED",

/**
 * Job is created and waiting for submission
 *
 * @generated from enum value: CREATED = 1;
 */
CREATED = "CREATED",

/**
 * Job is submitted and waiting for starting up
 *
 * @generated from enum value: SUBMITTED = 2;
 */
SUBMITTED = "SUBMITTED",

/**
 * Job is being executed.
 *
 * @generated from enum value: RUNNING = 3;
 */
RUNNING = "RUNNING",

/**
 * Job is waiting for scorer to be ready. Possible changes are from Submitted -> Pending or Running -> Pending.
 *
 * @generated from enum value: PENDING = 4;
 */
PENDING = "PENDING",

/**
 * Job has completed successfully.
 *
 * @generated from enum value: FINISHED = 5;
 */
FINISHED = "FINISHED",

/**
 * Job has completed with an error.
 *
 * @generated from enum value: FAILED = 6;
 */
FAILED = "FAILED",

/**
 * Job has been cancelled.
 *
 * @generated from enum value: CANCELLED = 7;
 */
CANCELLED = "CANCELLED",

/**
 * Job submission failed
 *
 * @generated from enum value: SUBMISSION_FAILED = 8;
 */
SUBMISSION_FAILED = "SUBMISSION_FAILED",

/**
 * Job cancellation has been started.
 *
 * @generated from enum value: CANCELLING = 9;
 */
CANCELLING = "CANCELLING",

/**
 * Job has been time out
 *
 * @generated from enum value: TIMEOUT = 10;
 */
TIMEOUT = "TIMEOUT",
}
/**
 * State represents the current state of the job.
 *
 * @generated from enum ai.h2o.mlops.batch.v1.Job.MonitoringState
 */
export enum Job_MonitoringState {
/**
 * Monitoring state is unspecified or unknown.
 *
 * @generated from enum value: MONITORING_STATE_UNKNOWN = 0;
 */
UNKNOWN = "MONITORING_STATE_UNKNOWN",

/**
 * Monitoring is not enabled or not applicable
 *
 * @generated from enum value: MONITORING_STATE_NONE = 1;
 */
NONE = "MONITORING_STATE_NONE",

/**
 * Monitoring pod deployment is pending
 *
 * @generated from enum value: MONITORING_STATE_PENDING = 2;
 */
PENDING = "MONITORING_STATE_PENDING",

/**
 * Monitoring pod is running and processing data
 *
 * @generated from enum value: MONITORING_STATE_RUNNING = 3;
 */
RUNNING = "MONITORING_STATE_RUNNING",

/**
 * Monitoring completed successfully
 *
 * @generated from enum value: MONITORING_STATE_FINISHED = 4;
 */
FINISHED = "MONITORING_STATE_FINISHED",

/**
 * Monitoring failed
 *
 * @generated from enum value: MONITORING_STATE_FAILED = 5;
 */
FAILED = "MONITORING_STATE_FAILED",
}
export const jobName = getNameParser<'workspace' | 'job'>("workspaces/{workspace}/jobs/{job}");
/**
 * Configuration for a data source from which batch processing input data
 * will be read. All fields are immutable after creation.
 *
 * @generated from message ai.h2o.mlops.batch.v1.Source
 */
export type Source = {
/**
 * Required. Reference to the SourceSpec resource that defines the source type
 * and capabilities (e.g., file system, database, cloud storage).
 * Cannot be changed after the sink is created.
 *
 * @generated from field: string spec = 1;
 */
spec: string;
/**
 * Required. Configuration parameters specific to the source type, such as
 * connection strings, authentication details, or format specifications.
 * Cannot be modified after the source is created.
 *
 * @generated from field: string config = 2;
 */
config: string;
/**
 * Required. The location or path from which data will be read,
 * such as a file path, database table name, or cloud storage URI.
 * Cannot be changed after the source is created.
 *
 * @generated from field: string location = 3;
 */
location: string;
/**
 * Specifies the mime type for file-based sources. This value is used to determine how the file data should be interpreted and processed.
 * Common mime types include:
 * - text/csv: For CSV (Comma-Separated Values) files.
 * - application/jsonl: For JSON Lines (newline-delimited JSON) format, typically used for structured data with one JSON object per line.
 * - application/json: For regular JSON files containing structured data.
 * - image/*: For image files of any format (e.g., image/png, image/jpeg).
 *
 * Providing an appropriate mime type is crucial for the correct handling of file data. If not specified, default behavior may apply.
 *
 * @generated from field: string mime_type = 4;
 */
mimeType?: string;
}
;
/**
 * Configuration for a data sink destination where batch processing results
 * will be written. All fields are immutable after creation.
 *
 * @generated from message ai.h2o.mlops.batch.v1.Sink
 */
export type Sink = {
/**
 * Required. Reference to the SinkSpec resource that defines the sink type
 * and capabilities (e.g., file system, database, cloud storage).
 * Cannot be changed after the sink is created.
 *
 * @generated from field: string spec = 1;
 */
spec: string;
/**
 * Required. Configuration parameters specific to the sink type, such as
 * connection strings, authentication details, or format specifications.
 * Cannot be modified after the sink is created.
 *
 * @generated from field: string config = 2;
 */
config: string;
/**
 * Required. The target location or path where data will be written,
 * such as a file path, database table name, or cloud storage URI.
 * Cannot be changed after the sink is created.
 *
 * @generated from field: string location = 3;
 */
location: string;
/**
 * Specifies the mime type for file-based sinks. This value determines the format used when writing data to the output files.
 * Common mime types include:
 * - text/csv: For CSV (Comma-Separated Values) format, used for structured tabular data.
 * - application/jsonl: For JSON Lines (newline-delimited JSON) format, where each line is a separate JSON object.
 * - application/json: For standard JSON format, used for structured data in a hierarchical or nested structure.
 *
 * Specifying the correct mime type is essential to ensure data is output in the desired format. If not specified, the system may apply a default format that may not meet expectations.
 *
 * @generated from field: string mime_type = 4;
 */
mimeType?: string;
}
;
/**
 * Configuration parameters for controlling batch processing behavior during
 * model inference, including batch size optimization settings.
 *
 * @generated from message ai.h2o.mlops.batch.v1.BatchParameters
 */
export type BatchParameters = {
/**
 * Optional. The number of records to send in one request to the scorer.
 * If not provided, 64 will be used as default. This value cannot be modified
 * after job creation due to the IMMUTABLE constraint.
 * Larger batch sizes can improve throughput but may increase memory usage.
 *
 * @generated from field: int32 mini_batch_size = 1;
 */
miniBatchSize?: number;
}
;
/**
 * Parameters for configuring model inference requests, including feature contributions,
 * prediction intervals, and record identification options.
 *
 * @generated from message ai.h2o.mlops.batch.v1.ModelRequestParameters
 */
export type ModelRequestParameters = {
/**
 * Note: mutually exclusive with include_input_features
 * Optional. Field name to use as a unique identifier for each prediction record.
 * When specified, this field's value will be included in the response to help
 * correlate predictions with input data.
 *
 * @generated from field: string id_field = 1;
 */
idField?: string;
/**
 * Optional. Type of Shapley value calculation to include in the response.
 * Determines whether and how feature contributions are computed and returned
 * alongside predictions.
 *
 * @generated from field: ai.h2o.mlops.batch.v1.ModelRequestParameters.ShapleyType request_contributions = 2;
 */
requestContributions?: ModelRequestParameters_ShapleyType;
/**
 * Optional. Whether to include prediction intervals in the model response.
 * When true, the response will contain confidence intervals or uncertainty
 * estimates for the predictions in addition to point predictions.
 *
 * @generated from field: bool request_prediction_intervals = 3;
 */
requestPredictionIntervals?: boolean;
/**
 * Note: mutually exclusive with id_field
 * Optional. Whether to include the original input features in the model response.
 * When true, the output will contain both the prediction results and the
 * corresponding input feature values, allowing easier correlation and debugging.
 *
 * @generated from field: bool include_input_features = 4;
 */
includeInputFeatures?: boolean;
}
;
/**
 * Enum defining the type of Shapley value calculation to be performed during scoring
 *
 * @generated from enum ai.h2o.mlops.batch.v1.ModelRequestParameters.ShapleyType
 */
export enum ModelRequestParameters_ShapleyType {
/**
 * Default value. Server will choose.
 *
 * @generated from enum value: SHAPLEY_TYPE_UNSPECIFIED = 0;
 */
SHAPLEY_TYPE_UNSPECIFIED = "SHAPLEY_TYPE_UNSPECIFIED",

/**
 * No Shapley value calculation will be performed.
 *
 * @generated from enum value: NONE = 1;
 */
NONE = "NONE",

/**
 * Calculate Shapley values using the original/raw feature values.
 *
 * @generated from enum value: ORIGINAL = 2;
 */
ORIGINAL = "ORIGINAL",

/**
 * Calculate Shapley values using transformed/preprocessed feature values.
 *
 * @generated from enum value: TRANSFORMED = 3;
 */
TRANSFORMED = "TRANSFORMED",
}
/**
 * Specification for configuring a deployed instance, including its composition,
 * resource allocation, environment, and Kubernetes settings.
 *
 * @generated from message ai.h2o.mlops.batch.v1.InstanceSpec
 */
export type InstanceSpec = {
/**
 * Required. The deployment composition.
 *
 * @generated from field: ai.h2o.mlops.batch.v1.DeploymentComposition deployment_composition = 2;
 */
deploymentComposition: DeploymentComposition;
/**
 * Optional. Kubernetes resource profile to use for the deployment.
 *
 * @generated from field: ai.h2o.mlops.batch.v1.ResourceSpec resource_spec = 3;
 */
resourceSpec?: ResourceSpec;
/**
 * Optional. The environment variables to set in the scorer runtime.
 *
 * @generated from field: map<string, string> environment_variables = 4;
 */
environmentVariables?: { [key: string]: string };
/**
 * Optional Kubernetes configuration shortcut options to apply.
 *
 * @generated from field: ai.h2o.mlops.batch.v1.KubernetesConfigShortcut kubernetes_config_shortcut = 5;
 */
kubernetesConfigShortcut?: KubernetesConfigShortcut;
}
;
/**
 * DeploymentComposition represents a deployment composition of a model.
 *
 * @generated from message ai.h2o.mlops.batch.v1.DeploymentComposition
 */
export type DeploymentComposition = {
/**
 * Required. ID of the experiment hosting the model to be deployed.
 *
 * @generated from field: string experiment_id = 1;
 */
experimentId: string;
/**
 * Required. Identifying name of the deployable artifact type.
 *
 * @generated from field: string artifact_type = 3;
 */
artifactType: string;
/**
 * Required. Identifying name of the artifact processor.
 *
 * @generated from field: string artifact_processor = 4;
 */
artifactProcessor: string;
/**
 * The runtime to use for this job. Can be specified as either:
 * - A full resource name: `workspaces/{workspace}/runtimes/{runtime}`
 * - A runtime ID: `{runtime}` (resolved relative to `workspaces/global`)
 * For backward compatibility, if only an ID is provided, it will be resolved
 * to `workspaces/global/runtimes/{runtime}`.
 *
 * @generated from field: string runtime = 5;
 */
runtime: string;
/**
 * The resource name of the RuntimeImageVersion resolved and populated by the
 * system at job creation time based on the specified runtime.
 * Format: `workspaces/{workspace}/runtimeImages/{runtime_image}/versions/{version}`.
 *
 * @generated from field: string runtime_image = 6;
 */
runtimeImage?: string;
}
;
/**
 * ResourceRequirement describes the scorer container resource requirements.
 *
 * @generated from message ai.h2o.mlops.batch.v1.ResourceRequirement
 */
export type ResourceRequirement = {
/**
 * Optional. Resource requests for the scorer container.
 * If requests is omitted, it defaults to limits if that is explicitly
 * specified, otherwise to an implementation-defined value.
 *
 * @generated from field: map<string, string> requests = 1;
 */
requests?: { [key: string]: string };
/**
 * Optional. Resource limits for the scorer container.
 * If not specified, there are no limits.
 *
 * @generated from field: map<string, string> limits = 2;
 */
limits?: { [key: string]: string };
}
;
/**
 * ResourceSpec describes the resource specification for the pod.
 *
 * @generated from message ai.h2o.mlops.batch.v1.ResourceSpec
 */
export type ResourceSpec = {
/**
 * Optional. Resource requirements for the scorer container.
 *
 * @generated from field: ai.h2o.mlops.batch.v1.ResourceRequirement resource_requirement = 1;
 */
resourceRequirement?: ResourceRequirement;
/**
 * Optional. Number of replicas for the scorer container.
 * Defaults to 1.
 *
 * @generated from field: int32 replicas = 2;
 */
replicas?: number;
/**
 * Optional. Number of available replicas for the scorer container which should available for processing batch scoring job.
 * Defaults is ceil(50% * replicas)
 * It cannot be greater than replicas
 *
 * @generated from field: int32 minimal_available_replicas = 3;
 */
minimalAvailableReplicas?: number;
}
;
/**
 * CompletionStats describe batch-scoring job completion statistics after it has been completed or terminated.
 *
 * @generated from message ai.h2o.mlops.batch.v1.CompletionStats
 */
export type CompletionStats = {
/**
 * Required. Number of processed input input when batch soring job is completed.
 *
 * @generated from field: int64 processed_rows = 1;
 */
processedRows?: BigIntString;
/**
 * Required. Number of finished pipeline count.
 *
 * @generated from field: int32 finished_pipeline_count = 2;
 */
finishedPipelineCount?: number;
/**
 * Required. List of failed pipelines which includes task_id and the pipeline_id
 *
 * @generated from field: repeated string failed_pipelines = 3;
 */
failedPipelines?: string[];
/**
 * Required. Number of rows that failed scoring.
 *
 * @generated from field: int64 error_rows_count = 4;
 */
errorRowsCount?: BigIntString;
}
;
/**
 * Shortcut configuration options that translate to expanded Kubernetes resource
 * configuration.
 *
 * @generated from message ai.h2o.mlops.batch.v1.KubernetesConfigShortcut
 */
export type KubernetesConfigShortcut = {
/**
 * Optional. The name of the KubernetesAffinityShortcut to apply to the batch-scoring job.
 *
 * @generated from field: string kubernetes_affinity_shortcut = 1;
 */
kubernetesAffinityShortcut?: string;
/**
 * Optional. The name of the KubernetesTolerationShortcut to apply to the batch-scoring job.
 *
 * @generated from field: string kubernetes_toleration_shortcut = 2;
 */
kubernetesTolerationShortcut?: string;
}
;
